'use client';
import { useEffect } from 'react';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import HeroSection from './components/HeroSection';
import ValuesSection from './components/ValuesSection';
import CatalogSection from './components/CatalogSection';
import CertificationsSection from './components/CertificationsSection';
import AboutSection from './components/AboutSection';
import StrengthsSection from './components/StrengthsSection';
import QualitySection from './components/QualitySection';
import LogisticsSection from './components/LogisticsSection';
import ServicesSection from './components/ServicesSection';
import ContactSection from './components/ContactSection';

export default function Homepage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal')
    if (!reveals?.length) return

    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    )
    reveals?.forEach((el) => observer?.observe(el))

    return () => observer?.disconnect();
  }, [])

  return (
    <main className="min-h-screen bg-background">
      <Header />
      <HeroSection />
      <AboutSection />
      <StrengthsSection />
      <CatalogSection />
      <QualitySection />
      <LogisticsSection />
      <ValuesSection />
      {/* <ServicesSection /> */}
      <CertificationsSection />
      <ContactSection />
      <Footer />
    </main>
  )
}
